import { render, staticRenderFns } from "./SendZapi.vue?vue&type=template&id=752f2506"
import script from "./SendZapi.vue?vue&type=script&lang=js"
export * from "./SendZapi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports